import { Model } from 'modules/core/lib/mobx-rest'

interface IIdentifierType {
  [key: string]: any
}

class IdentifierType extends Model<IIdentifierType> {
  static urlRoot() {
    return '/identifier_types'
  }

  get primaryKey(): string {
    return 'slug'
  }
}

export default IdentifierType
